/**
 * Chi può operare quale fase del processo.
 *
 * Regole pure, senza store né i18n: la stessa forma di utils/fieldRules.js. Lo strato con stato
 * (ruolo dell'utente, configurazioni caricate, etichette) sta in composables/useWorkflowAccess.js.
 *
 * ATTENZIONE — la stessa regola vive nel Backend, in WorkflowAccessService.CanOperate. Questa copia
 * serve solo a non mostrare pulsanti che il server rifiuterebbe: l'ultima parola è sempre là.
 * Se si cambia una regola qui, aggiornare anche quella (e viceversa).
 */

/** Ruoli che operano tutte le fasi e non si dichiarano in cfg.json. */
export const PRIVILEGED_ROLES = ['admin', 'superadmin']

/** Fuori dalle proprie fasi i processi restano visibili, ma in sola lettura. */
export const POLICY_READONLY = 'readonly'

/** Fuori dalle proprie fasi i processi spariscono dalle liste. */
export const POLICY_HIDDEN = 'hidden'

export const isPrivilegedRole = (role) => PRIVILEGED_ROLES.includes(role)

/** I profili dichiarati da uno stato. Lista vuota = fase di tutti. */
export const rolesOfStatus = (status) =>
  Array.isArray(status?.roles) ? status.roles.filter(Boolean) : []

/**
 * Il profilo lavora questa fase? Vero per admin e superadmin, per gli stati che non dichiarano
 * `roles` — ed è questo che rende retrocompatibile un cfg.json non ancora configurato — e per i
 * profili elencati dallo stato.
 */
export const canRoleOperateStatus = (role, status) => {
  if (isPrivilegedRole(role)) return true

  const declared = rolesOfStatus(status)
  if (declared.length === 0) return true

  return !!role && declared.includes(role)
}
